export const CIRCULAR_PROGRESS_SIZE = 40;
export const SCROLL_MARGIN = 2.5;

export const DISPLAY_FIELD_MAIN_PRIMARY = 0;
export const DISPLAY_FIELD_MAIN_SECONDARY = 1;
export const DISPLAY_FIELD_DESCRIPTION_PRIMARY = 2;
export const DISPLAY_FIELD_DESCRIPTION_SECONDARY = 3;
export const DISPLAY_FIELD_ADDITIONAL_PRIMARY = 4;
export const DISPLAY_FIELD_ADDITIONAL_SECONDARY = 5;
